module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-112.1f6ed66e.svg";